<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <div class="membername" *ngFor="let m of filterBy('index')">
                <div *ngIf="m.isActive">
                    <p style="font-weight: 600; font-size: 22px">{{m.fullname}} <br /><span
                            style="font-weight: 400; font-size: 16px; position: relative; bottom: 10px; color: #6B7072">{{m.position}}</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="col-sm-12">
            <div class="row">
                <div class="col-12"><span class="arrowControl" (click)="prev(true)"><img
                            src="../../assets/members/arrows/Left.png" width="22" style="margin-top: -2px;" /></span>
                    <div class="membersStage" style="display: inline-block; margin-left: 15px; margin-right: 15px;">
                        <div class="memberselector" *ngFor="let m of filterBy('index')" style="vertical-align: middle;"
                            [ngClass]="m.isActive ? 'active' : ''" (click)="activateSlide(m)" angulartics2On="click"
                            angularticsAction="ClickedPerson" angularticsValue="{{m.fullname}}">
                            <div style="border-radius: 50%; background: darkblue; margin-left:10px; margin-right:10px;">
                                <img src="{{m.image}}" style="width: inherit; height: inherit;" /></div>
                        </div>
                    </div>
                    <!--.d-inline.d-sm-none--><span class="arrowControl" (click)="next(true)"><img
                            src="../../assets/members/arrows/Right.png" width="22" style="margin-top: -2px;" /></span>
                </div>
            </div>
        </div>
        <div class="col-sm-12">
            <div class="memberdetails" *ngFor="let m of filterBy('index')"
                style=" margin-top: 16px;margin-bottom: 20px">
                <div *ngIf="m.isActive">
                    <p
                        style="max-width: 860px; margin-left: auto; margin-right: auto; font-weight: 400; font-size: 16px; color: #6B7072; margin-bottom: 15px">
                        {{m.description}}</p><a *ngIf="m.email &amp;&amp; showEmails" href="mailto:{{m.email}}"
                        style="display: block; margin-bottom: 10px"><img
                            src="../../assets/members/icons/mailIcon@2x.png" width="20"
                            style="margin-right: 10px; position: relative; bottom: 2px" />{{m.email}}</a>
                    <a href="tel:{{m.mobile}}" style="display: block"> <img
                            src="../../assets/members/icons/phoneIcon@2x.png" width="24"
                            style="margin-right: 10px; position: relative; bottom: 2px" />{{m.mobile}}</a>
                </div>
            </div>
        </div>
    </div>
</div>